/**
 * Card component.
 */

import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '@/utils/cn';
import './card.scss';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn('card', className)} {...props} />;
});

Card.displayName = 'Card';

